/**
 * Reefer Stop Measurement Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.reeferStopMeasurementFormatter = function(value, row) {
    let html = '';
    if (parseInt(row.can_stop, 10) === 1) {
        html += '<button class="button-reefer-stop-measurement btn btn-sm btn-outline-danger" data-id="'+row.reefer_id+'" data-container-number="'+row.container_number+'">';
        html += __('Stop measurement');
        html += '</button>';
    } else {
        html += '<button class="btn btn-sm btn-outline-secondary disabled">';
        html += __('Stop measurement');
        html += '</button>';
    }
    return html;
};
